export default function (state, getters, rootState, rootGetters) {
    // return rootGetters['legends/legend']('Invoices');
    if (rootGetters['legends/legend']) {
        return rootGetters['legends/legend']('Invoices');
    } else {
        return null
    }
}
